import { render } from "./SmallArrowTagOff.vue?vue&type=template&id=cf0d0636"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/SmallArrowTagOff.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf0d0636"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf0d0636', __exports__)) {
    api.reload('cf0d0636', __exports__)
  }
  
  module.hot.accept("./SmallArrowTagOff.vue?vue&type=template&id=cf0d0636", () => {
    api.rerender('cf0d0636', render)
  })

}


export default __exports__